import { InjectionToken } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { IAppConfig } from '@models/app-config/app.config.model';

export const APP_CONFIG_SERVICE = new InjectionToken<IAppConfig>('app.config');

export const APP_CONFIG: IAppConfig = {
  apiEndpoint: environment.apiEndpoint,
};
